import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { MenuButtonWebElement } from './MenuButtonWebElement';
export { MenuButtonWebElement };

/**
 * Retrieve an instance of [MenuButtonWebElement](../classes/MenuButtonWebElement.html).
 * @example
 * ```javascript
 * import { findMenuButton } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findMenuButton(driver, By.id('my-oj-c-menu-button'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findMenuButton(driver: DriverLike, by: By): Promise<MenuButtonWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type MenuButtonWebElement
  if (!(webEl instanceof MenuButtonWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'MenuButtonWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findMenuButton(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${MenuButtonWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-menu-button', MenuButtonWebElement);
